import React from "react";
import {update_status_code} from "../../utility/browser";
import { setRobotsNoindex } from "../../utility/head";

export default class Page404 extends React.Component {
    componentDidMount() {
        // update status code
        update_status_code(404);

        setRobotsNoindex();
    }

    render() {
        return (<dwc-404-page />);
    }
}
